<template>
  <div class="location">
    <div class="title">{{ title }}</div>
    <div class="content">
      <div class="list" v-for="item of list" :key="item">
        <img :src="item.img" alt="" />
        <div class="headline">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: ()=>{
        return []
      }
    }
  },
  data: function() {
    return {
      data: {
        menu_list: []
      },
      location: [
        {
          title: '灵活的教学模式',
          desc: '教师控播、学生控播、双人模式、自由模式、自主学习',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/5.png'
        },
        {
          title: '丰富的课件资源',
          desc: '机械类3D模型',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/6.png'
        },
        {
          title: '多终端设备支持',
          desc: 'PC、大屏、燧光MR、未来感知、HTC vive、安卓Pad',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/7.png'
        },
        {
          title: '多维度数据统计分析',
          desc: '设备和课件为维度，统计教学和学习数据',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/8.png'
        },
        {
          title: '',
          desc: '',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/jiang/9.png'
        }
      ],
    };
  },
  created() {},
  methods: {
    go() {
      this.$router.push({
        name: 'eg'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.location {
  width: 1200px;
  height: 522px;
  margin: 0 auto;
  .title {
    margin-top: 124px;
    text-align: center;
    font-size: 42px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.6);
    line-height: 1;
  }
  .content {
    display: flex;
    align-items: center;
    margin-top: 33px;
    justify-content: space-between;
    .list {
      width: 224px;
      height: 303px;
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid;
      border-image: linear-gradient(
          180deg,
          rgba(157, 157, 157, 0),
          rgba(99, 99, 99, 0.3)
        )
        1 1;
      text-align: center;
      padding: 0 30px;
      box-sizing: border-box;
      overflow: hidden;
      img {
        width: 60px;
        height: 60px;
        margin: 0 auto;
        margin-top: 10px;
        display: block;
      }
      .headline {
        font-size: 36px;
        font-weight: bold;
        color: #5e5e5e;
        line-height: 54px;
        margin-top: 18px;
      }
      .desc {
        margin-top: 10px;
        font-size: 20px;
        font-weight: 300;
        color: #5e5e5e;
        line-height: 36px;
      }
    }
  }
}
</style>
